module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/contact-en/cabecera.jpg
// module id = biWA
// module chunks = 0